"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _tokens = require("../../tokens");
var _responsive = require("../../helpers/responsive");
var _layout = require("../../helpers/layout");
var _responsiveProps = require("../../internal/responsiveProps");
var _formatting = require("../../internal/formatting");
var _filterProps = require("../../internal/filterProps");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
const elementStyles = (0, _styledComponents.css)(["", " ", " ", " ", " ", " ", " ", " ", " ", " ", ""], _ref => {
  let {
    container,
    containerPaddingTop,
    containerPaddingBottom
  } = _ref;
  return container && (0, _styledComponents.css)(["max-width:", ";margin:0 auto;padding:", ";", " ", ""], _tokens.CONTENT_OUTER_WIDTH, (0, _formatting.formatGtrValues)([containerPaddingTop !== null && containerPaddingTop !== void 0 ? containerPaddingTop : _tokens.CONTAINER_PADDING_VERTICAL_AT_BP.S, _tokens.CONTAINER_PADDING_HORIZONTAL_AT_BP.S, containerPaddingBottom !== null && containerPaddingBottom !== void 0 ? containerPaddingBottom : _tokens.CONTAINER_PADDING_VERTICAL_AT_BP.S]), _responsive.screenMin.m`
        padding: ${(0, _formatting.formatGtrValues)([containerPaddingTop !== null && containerPaddingTop !== void 0 ? containerPaddingTop : _tokens.CONTAINER_PADDING_VERTICAL_AT_BP.M, _tokens.CONTAINER_PADDING_HORIZONTAL_AT_BP.M, containerPaddingBottom !== null && containerPaddingBottom !== void 0 ? containerPaddingBottom : _tokens.CONTAINER_PADDING_VERTICAL_AT_BP.M])};
      `, _responsive.screenMin.l`
        padding: ${(0, _formatting.formatGtrValues)([containerPaddingTop !== null && containerPaddingTop !== void 0 ? containerPaddingTop : _tokens.CONTAINER_PADDING_VERTICAL_AT_BP.L, _tokens.CONTAINER_PADDING_HORIZONTAL_AT_BP.L, containerPaddingBottom !== null && containerPaddingBottom !== void 0 ? containerPaddingBottom : _tokens.CONTAINER_PADDING_VERTICAL_AT_BP.L])};
      `);
}, _ref2 => {
  let {
    separator
  } = _ref2;
  return separator && (0, _styledComponents.css)(["margin:", ";", " ", ""], (0, _formatting.formatGtrValues)([_tokens.SEPARATOR_MARGIN_AT_BP.S, 0]), _responsive.screenMin.m`
        margin: ${(0, _formatting.formatGtrValues)([_tokens.SEPARATOR_MARGIN_AT_BP.M, 0])};
      `, _responsive.screenMin.l`
        margin: ${(0, _formatting.formatGtrValues)([_tokens.SEPARATOR_MARGIN_AT_BP.L, 0])};
      `);
}, props => (0, _responsiveProps.responsiveCssProps)({
  props,
  propName: 'margin',
  cssProperty: 'margin',
  formatValues: _formatting.formatGtrValues
}), props => (0, _responsiveProps.responsiveCssProps)({
  props,
  propName: 'padding',
  cssProperty: 'padding',
  formatValues: _formatting.formatGtrValues
}), props => (0, _responsiveProps.responsiveCssProps)({
  props,
  propName: 'bordered',
  cssProperty: 'border',
  formatValues: border => border ? `1px solid ${_tokens.COLOR.GREY.LIGHT}` : ''
}), props => (0, _responsiveProps.responsiveCssProps)({
  props,
  propName: 'centered',
  cssProperty: 'text-align',
  formatValues: center => center ? 'center' : 'left'
}), _ref3 => {
  let {
    background
  } = _ref3;
  return background && `background: ${background};`;
}, _ref4 => {
  let {
    maxWidth
  } = _ref4;
  return maxWidth && `max-width: ${typeof maxWidth === 'string' ? maxWidth : (0, _formatting.formatGtrValue)(maxWidth)};`;
}, _ref5 => {
  let {
    maxWidthInColumns
  } = _ref5;
  return maxWidthInColumns && `max-width: ${(0, _layout.getWidthOfContainerColumns)(maxWidthInColumns, 'L')}px;`;
}, _ref6 => {
  let {
    borderRadius
  } = _ref6;
  return borderRadius && `border-radius: ${_tokens.BORDER.RADIUS[borderRadius]};`;
});
const StyledWrapper = (0, _styledComponents.default)(_ref7 => {
  let {
    omitProps = {},
    tag,
    ...props
  } = _ref7;
  const filteredProps = (0, _filterProps.filterProps)({
    props,
    keys: ['container', 'containerVerticalPadding', 'containerPaddingTop', 'containerPaddingBottom', 'separator', 'background', 'maxWidth', 'maxWidthInColumns', 'borderRadius', 'bumpSpecificity', 'noTrim', ...(omitProps.keys || [])],
    responsiveKeys: ['margin', 'padding', 'bordered', 'centered', ...(omitProps.responsiveKeys || [])]
  });
  const Element = tag;
  return /*#__PURE__*/_react.default.createElement(Element, filteredProps);
}).withConfig({
  displayName: "StyledWrapper",
  componentId: "sc-1py7b9c-0"
})(["", ";", ""], _ref8 => {
  let {
    bumpSpecificity
  } = _ref8;
  return bumpSpecificity ? (0, _styledComponents.css)(["&&{", "}"], elementStyles) : elementStyles;
}, _ref9 => {
  let {
    noTrim
  } = _ref9;
  return !noTrim && `
      > *:first-child {
        margin-top: 0;
      }

      > *:last-child {
        margin-bottom: 0;
      }
  `;
});

/**
## Usage

```jsx
import { Wrapper } from '@farewill/ui'
```

## Notes

`<Wrapper>`s are the building blocks of layout. They are extended by the Grid components and provide props for box-level styling on all screen sizes.

A `<Wrapper>` with no props will be a plain div, but will remove the top margin from its first child and the bottom margin from its last child. This means that inside of a `<Wrapper>` we can use `<Wrapper margin={['L', 0]}>`s without worrying about the hanging margins. Where this feature is unwanted, for example when building horizontal layouts, it can be removed using `noTrim`.

`margin` and `padding` values can be provided as an array and output as space-separated values. If provided as numbers the values are formatted in pixels, if they are strings and a key value of `GTR` that is the format, otherwise output as keywords.
*/
const Wrapper = _ref10 => {
  let {
    children,
    containerVerticalPadding,
    containerPaddingTop,
    containerPaddingBottom,
    tag = 'div',
    ...props
  } = _ref10;
  if (containerVerticalPadding) console.warn('The `containerVerticalPadding` prop on <Wrapper> has been deprecated in favour of `containerPaddingTop` and `containerPaddingBottom`, see https://github.com/farewill/ui/pull/57 for more details.');
  return /*#__PURE__*/_react.default.createElement(StyledWrapper, _extends({
    tag: tag,
    containerPaddingTop: containerPaddingTop !== null && containerPaddingTop !== void 0 ? containerPaddingTop : containerVerticalPadding,
    containerPaddingBottom: containerPaddingBottom !== null && containerPaddingBottom !== void 0 ? containerPaddingBottom : containerVerticalPadding
  }, props), children);
};
var _default = exports.default = Wrapper;